<template>
  <Benefit>
    {{ i18n(translations.title) }}
    <template #appendix>
      {{ i18n(translations.body) }}
    </template>
  </Benefit>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import Benefit from '../Benefit/Benefit.vue'

import translations from './SecondSim.translations'

const i18n = useI18n()
</script>
